import React, { useEffect, useState } from "react";
import CoachTimeSlotBooking from "./CoachTimeSlotBooking"; // Import the CoachTimeSlotBooking component
import { Box, Typography, Button } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import EventAvailableIcon from "@mui/icons-material/EventAvailable"; // MUI icon for empty state
import { useNavigate } from "react-router-dom";
import CoachRatingPopup from "./CoachRatingPopup";

import { Rating } from "@mui/material";
import { cancelDoctorAppointment, fetchPlayerCoachAppointments } from "../../apiservices/ApiService";
import { getCoachId } from "../../common/Utils";
import PWAHeader from "../../common/PWAHeader";

function CoachConsultationUI() {

  const fixUrlProtocol = (url) => {
    if (!url) return '';
    return url.startsWith('http:') ? url.replace(/^http:/, 'https:') : url;
  };
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [view, setView] = useState("home"); // Manage views: "home" or "coachTimeSlotBooking"
  const [selectedAppointmentData, setSelectedAppointmentData] = useState(null); // Store data for CoachTimeSlotBooking
  
    const coachId = getCoachId();

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (!hasMore) return;
      setIsLoading(true);
      try {
        const response = await fetchPlayerCoachAppointments({ pagination, coachId });
        if (response !== null) {
          const formattedData = response.upcoming.map((appointment) => ({
            ...appointment,
            formattedDate: formatDate(appointment.date, appointment.slot),
          }));
          const formattedData2 = response.past.map((appointment) => ({
            ...appointment,
            formattedDate: formatDate(appointment.date, appointment.slot),
          }));
          setData([...formattedData, ...formattedData2]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [pagination, coachId, hasMore]);

  const formatDate = (date, time) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dateObj = new Date(date);
    const day = dateObj.getDate();
    const month = months[dateObj.getMonth()];
    const year = dateObj.getFullYear();
    return `${day} ${month} ${year} at ${time}`;
  };

  const handleBookConsult = () => {
    setSelectedAppointmentData({
      appointments: data.appointments,
      bannerImage: data.bannerImage,
      title: data.title,
    });
    setView("coachTimeSlotBooking");
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      {view === "home" ? (
        <div  style={{ backgroundColor: "rgba(255, 152, 0, 0.11)", color: "#771615" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              color: "#771615",
              padding: "10px 16px",
              background: "linear-gradient(90deg, #fff 0%, rgba(255, 152, 0, 0.11) 70%)",
              borderBottom: "1px solid #ddd",
            }}
          >
            <ArrowBackIosIcon sx={{ cursor: "pointer" }} onClick={() => goBack()} />
            <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center" }}>
              Consult with GOQii Coach
            </Typography>
          </Box>

          {/* <PWAHeader title={"Consult with GOQii Coach"} onBack={goBack()} /> */}

          <div>
            {data.length > 0 ? (
              <div style={styles.container}>
                {data.map((appointment, index) => (
                  <div key={index} style={styles.card}>
                    <div style={styles.leftSection}>
                      <Typography variant="body1">
                        {appointment.callType} Call
                      </Typography>
                      <Typography variant="body2">{appointment.coachName}</Typography>
                      <Typography variant="body2">{appointment.formattedDate}</Typography>
                    </div>
                    <div style={styles.rightSection}>
                      <img src={fixUrlProtocol(appointment.coachImage)} alt="Coach" style={styles.coachImage} />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "80vh",
                  textAlign: "center",
                }}
              >
                <EventAvailableIcon
                  sx={{ fontSize: "80px", color: "gray", marginBottom: "16px" }}
                />
                <Typography variant="h6" color="text.primary" sx={{ marginBottom: "8px" }}>
                  No Appointments Yet
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ marginBottom: "24px" }}>
                  You currently have no appointments with a GOQii Coach.
                  <br />
                  Click below to book your first consultation.
                </Typography>
               
              </Box>
            )}

            {/* Floating Button */}
            <div style={styles.floatingButtonContainer}>
              <button style={styles.floatingButton} onClick={handleBookConsult}>
                Book A Coach Call
              </button>
            </div>
          </div>
        </div>
      ) : view === "coachTimeSlotBooking" ? (
        <CoachTimeSlotBooking
          data={selectedAppointmentData}
          onBack={() => setView("home")}
        />
      ) : null}
    </>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "16px",
  },
  card: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "linear-gradient(to top, #fff 0%, rgba(255, 152, 0, 0.11) 70%)",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  leftSection: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  rightSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  coachImage: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  floatingButtonContainer: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 1000,
  },
  floatingButton: {
    background: "linear-gradient(90deg, #681517 0%, #FF9800 100%)",
    color: "#fff",
    border: "none",
    borderRadius: "50px",
    padding: "12px 20px",
    fontSize: "14px",
    cursor: "pointer",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
  },
};

export default CoachConsultationUI;